const DomHelper = {
    addSelectedClass: function (node) {
        node.classList.add('selected');
    },
    removeSelectedClass: function (node) {
        node.classList.remove('selected');
    },
    getSaveButtonNode: function (domRoot) {
        return domRoot.querySelector('#language-selector-save');
    },
    getCountryNodeList: function (domRoot) {
        return domRoot.querySelector('#languageSelectorModal .countries').querySelectorAll('.country');
    },
    getLargeLanguageSelectorNodeList: function (domRoot) {
        return domRoot.querySelectorAll('[name="large-language-selector-cta"]');
    },
    getSmallLanguageSelectorNodeList: function (domRoot) {
        return domRoot.querySelectorAll('[name="small-language-selector-cta"]');
    },
    getLanguageNodeList: function (domRoot, filters) {
        let additionnalQuerySelector = '';

        if (filters) {
            additionnalQuerySelector += filters.excludeSelectedNodes === true ? ':not(.selected)' : '';
        }

        return domRoot.querySelector('#languageSelectorModal .languages').querySelectorAll('.language' + additionnalQuerySelector);
    },
    toggleSelectedClass: function (node, nextCode) {
        if (node.getAttribute('data-value') === nextCode) {
            DomHelper.addSelectedClass(node);
        } else {
            DomHelper.removeSelectedClass(node);
        }
    },
    updateCountriesSelection: function (domRoot, nextCountryCode) {
        this.getCountryNodeList(domRoot).forEach((node) => {
            this.toggleSelectedClass(node, nextCountryCode);
        });
    },
    updateLanguagesSelection: function (domRoot, nextLanguageCode) {
        this.getLanguageNodeList(domRoot).forEach((node) => {
            this.toggleSelectedClass(node, nextLanguageCode);
        });
    },
    disableSaveButton: function (domRoot) {
        this.getSaveButtonNode(domRoot).disabled = true;
    },
    enableSaveButton: function (domRoot) {
        this.getSaveButtonNode(domRoot).disabled = false;
    },
};

export default DomHelper;
